import { ReactNode, useEffect } from 'react';

import { useStore } from '../../store';
import { InvestorSelector } from '../investorselection/InvestorSelector';

import { ApplicationNavSection } from './ApplicationNavSection';
import { DetailsPageNavSection } from './DetailsPageNavSection';

import styles from './navigation.module.scss';

type NavigationProps = {
  userMenuButton: ReactNode;
  isPending?: boolean;
};

const UserMenu: React.FC<Pick<NavigationProps, 'userMenuButton'>> = ({
  userMenuButton,
}) => {
  const collapsed = useStore((state) => state.isNavigationCollapsed);

  return collapsed ? (
    <div className={styles.user}>{userMenuButton}</div>
  ) : (
    <InvestorSelector className={styles['investor-selection']} />
  );
};

export const Navigation: React.FC<NavigationProps> = ({
  userMenuButton,
  isPending,
}) => {
  const collapsed = useStore((state) => state.isNavigationCollapsed);

  useEffect(() => {
    document.body.classList.toggle('with-sidebar--open', !collapsed);
    document.body.classList.toggle('with-sidebar--closed', collapsed);
  }, [collapsed]);

  return (
    <>
      <UserMenu userMenuButton={userMenuButton} />
      <ApplicationNavSection isPending={isPending} />
      <DetailsPageNavSection isPending={isPending} />
    </>
  );
};
